<template >
    <div class="Week">
        Week - неделя
    </div>
</template>
<script>
export default {
    name: 'Week'
}
</script>
<style lang="">
    
</style>